
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPanelLeftOpen as ObiPanelLeftOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-panel-left-open.js';
 
 
 

 
 export const ObiPanelLeftOpen = createComponent({
   react: React,
   tagName: 'obi-panel-left-open',
   elementClass: ObiPanelLeftOpenElement,
   events: {
     
   }
  });
 
 